import { Component } from "react";
import { decode as base64_decode, encode as base64_encode } from "base-64";

import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { Button, Image, Typography, Modal, message } from "antd";
import Cookies from "universal-cookie";
import CreditRequestAdd from "./CreditRequestAdd";
import DistributorFleetCountStore from "../store/DistributorFleetCountStore";
const { Title } = Typography;
class DistributorCredits extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.DistributorFleetCountStore = new DistributorFleetCountStore(this);
    // this.state = {};
    // this.showLaunchingItems = {
    //   livetracking: false,
    //   dashboard: false,
    //   historytracking: false,
    //   detailtracking: false,
    //   parentalertreportlist: false,
    //   master: false,
    //   AdvanceDashboard: false,
    //   vehiclelist: false,
    //   parentreport: false,
    //   maintenancedashboard: false,
    //   showHelpModal: false,
    //   showLaunchingDashboard: 2,
    // };
    this.state = {
      openCreditForm: false,
      credits: 0,
      renewCredits: 0,
      totalCredits: 0,
      name: '',
      storedUserType: ''
    }
  }

  componentDidMount() {
    const data = JSON.parse(base64_decode(this.cookies.get("data")));
    const storedUserType = parseInt(localStorage.getItem("originalUserType"));

    this.setState({ name: data.userName, storedUserType: storedUserType });


    this.getCreditCount();
  }

  responseMsg = async (response) => {
    // console.log(resp);
    if (response?.success === "S") {
      message.success(response.message);
      // this.props.navigate("/companylist");
      this.setState({ openCreditForm: false });
      this.setState({ listDataUpdate: true });
    } else {
      if (response.errors[0].companyname) {
        message.error(this.context.translate(response.errors[0]?.companyname));
      }
      if (response.errors[0]?.username) {
        message.error(this.context.translate(response.errors[0]?.username));
      }
      this.setState({ loading: false });
    }
  };
  closeModal = () => {
    this.setState({ openCreditForm: false });
  };

  updateDashboard = (value) => {
    const encodedCookieData = this.cookies.get("data");
    const decodedCookieData = JSON.parse(base64_decode(encodedCookieData));
    decodedCookieData.showLaunchingDashboard = value;
    console.log(decodedCookieData, "decoded cookidata");
    const updatedEncodedCookieData = base64_encode(
      JSON.stringify(decodedCookieData)
    );
    this.cookies.set("data", updatedEncodedCookieData, { path: "/" });
    //this.setState({ update: 1 });
  };



  handleRedirect = (dashboardType, path) => {
    this.updateDashboard(dashboardType);
    this.props.navigate(path);
  };

  getCreditCount = async (value) => {
    const getCreditData = await this.DistributorFleetCountStore.getCreditData({
      userId: this.props.getUserData().userId,
      companyId: this.props.getUserData().userCompanyId
    });

    await this.setState({
      credits: getCreditData.credits,
      renewCredits: getCreditData.renewCredits,
      totalCredits: getCreditData.totalCredits
    });
  };


  render() {
    return (
      <>
        <div className="creditapp-container">
          <div className="login-overlay">
            {/* Logo Section */}
            <div className="container mt-4" style={{ textAlign: 'center', display: 'flex' }}>
              <div className="text-start">
                <i
                  class="bi bi-arrow-left-circle"
                  style={{
                    color: "white",
                    fontSize: "25px",
                    marginInlineStart: "25px",
                  }}
                  onClick={async () => {
                    this.props.navigate("/DistributorOptionsMain")
                  }}
                ></i>
              </div>
              <Image
                src={require('../assets/images/swd-dashboard-st.png')}
                alt="SecureTrackX"
                preview={false}
                className="mainLogo"
              />
              <div className=""></div>
            </div>


            <Title level={5} className="white-text distributor-title" style={{ marginBottom: '5px', color: 'white' }}>
              {this.state.name}
            </Title>


            {/* Login Circles */}
            <div className="distlogin-section">
              {/* SecurePath Circle */}
              <div className="d-flex gap-15">

                {/* SecureTrack Basic Circle */}
                <div className="distmaincircle login-circle">
                  <div className="distmainbred text-center">
                    <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                      {this.context.translate('_BALANCE_CREDITS_AVAILABLE_')}:{this.state.totalCredits}
                    </Title>

                  </div>
                </div>

                <div className="action-buttons">
                  <div className="btn-with-icon"
                    onClick={() => this.handleRedirect(0, "/creditlist/New")}
                  >

                    <Button type="primary" className="action-btn">{this.context.translate('_NEW_')}
                      <span style={{ color: '#FFF', padding: '0px 8px', fontSize: '1rem', }}>
                        {this.state.credits}
                      </span>
                    </Button>


                    {/* <div className="circle-icon" /> */}
                    <div className="distcreditbtncircle login-circle">
                      <div className="distloginbgblack text-center">
                        <Image
                          src={require('../assets/images/st-credit-arrow.png')}
                          alt="SecureTrackX"
                          preview={false}
                          className="btnicon"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="btn-with-icon"
                    onClick={() => this.handleRedirect(0, "/creditlist/Renew")}
                  >
                    <Button type="primary" className="action-btn">{this.context.translate('_RENEWAL1_')}
                      <span style={{ color: '#FFF', padding: '0px 8px', fontSize: '1rem', }}>
                        {this.state.renewCredits}
                      </span>
                    </Button>

                    {/* <div className="circle-icon" /> */}
                    <div className="distcreditbtncircle login-circle" >
                      <div className="distloginbgblack text-center">
                        <Image
                          src={require('../assets/images/st-credit-arrow.png')}
                          alt="SecureTrackX"
                          preview={false}
                          className="btnicon"
                        />
                      </div>
                    </div>
                  </div>
                </div>

              </div>


              {this.state.storedUserType != 8 && (
                <div className="footer-button">
                  <div className="d-flex ringbutton">
                    <div className="circle-icon" />
                    <div className="circle-icon" />
                  </div>
                  <Button type="primary" className="request-btn"
                    onClick={() =>
                      this.setState({
                        openCreditForm: true
                      })
                    }>{this.context.translate('_REQUEST_FOR_CREDITS_')}</Button>
                </div>
              )}

            </div>
          </div>
          {this.state.openCreditForm && (
            <Modal
              bodyStyle={{ height: "645px" }}
              className="formShowModal" //  {/* css class */}
              // title="User Details"
              title={this.context.translate("_REQUEST_CREDIT_")}
              centered
              visible={this.state.openCreditForm}
              footer={null}
              onCancel={() => {
                this.setState({ openCreditForm: false, userId: "" });
              }}
              width={665}
            >
              <div>
                <CreditRequestAdd
                  userId={this.state.userId}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </Modal>
          )}
        </div>
      </>
    );
  }
}
DistributorCredits.contextType = StoreContext;
export default observer(withRouter(DistributorCredits));
